<template>
  <v-dialog
    v-model="isActive"
    @click:outside="closeDialog()"
    max-width="500"
    scrollable
  >
    <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
      <v-card>
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Buscar Registro
            </v-card-title>
          </v-img>
        </v-card-title>

        <v-card-text>
          <v-form>
            <v-row dense justify="center">
              <!-- Agente -->
              <v-col cols="12">
                <v-select
                  :items="AgentList"
                  item-text="name"
                  item-value="id"
                  v-model="payload.userId"
                  class="rounded-small"
                  label="Nombre"
                  prepend-inner-icon="mdi-text-short"
                  required
                  filled
                  rounded
                  dense
                  clearable
                >
                </v-select>
              </v-col>
              <!-- Fecha -->
              <v-col cols="12">
                <regular-date-range-picker @dates:change="getRangeDates" />
              </v-col>

              <!-- Numero -->
              <v-col cols="12">
                <ValidationProvider
                  name="Numero"
                  rules="numeric"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.number"
                    :error-messages="errors"
                    class="rounded-small"
                    label="Numero"
                    prepend-inner-icon="mdi-numeric"
                    required
                    filled
                    rounded
                    dense
                    clearable
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="closeDialog()"
            >
              Cancelar
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="handleSubmit(submitForm)"
            >
              Buscar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import RegularDateRangePicker from "../DatePickers/RegularDateRangePicker.vue";
export default {
  components: { RegularDateRangePicker },

  props: {
    isActive: {
      type: Boolean
    }
  },

  data() {
    return {
      isDateMenuOpen: false,
      payload: {}
    };
  },

  computed: {
    AgentList() {
      return this.$store.getters["agents/GET_ALL_AGENTS"];
    }
  },

  created() {
    if (!this.AgentList.length) this.$store.dispatch("agents/GET_ALL_AGENTS");
  },

  methods: {
    closeDialog(params = null) {
      this.$emit("dialog:close", params);
    },

    getRangeDates(dates) {
      this.payload.dateStart = dates[0];
      this.payload.dateEnd = dates[1];
    },

    submitForm() {
      const params = {
        ...this.getNonEmptyAttributes(this.payload)
      };
      this.closeDialog(Object.keys(params).length ? params : null);
    },

    getNonEmptyAttributes(obj) {
      return Object.keys(obj)
        .filter((k) => ![null, ""].includes(obj[k]))
        .reduce((a, k) => ({ ...a, [k]: obj[k] }), {});
    }
  }
};
</script>

<style></style>
